import {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId as allSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'
import FormSelect, {formSelectSizes} from '@adv-mt/mt-form-select'
import FormSelectToggle from '@adv-mt/mt-form-select-toggle'

import {ICONS_BY_TRANSMISSION_TYPE} from './config.js'

const LEGACY_WRAPPER = 'legacy'

const FormTransmission = ({
  isSelectToggle = false,
  onChange,
  overlayContentRef,
  type,
  value,
  withLabel,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {transmissionTypes, DEFAULT_TRANSMISSION_TYPE, FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const currentValue = value || DEFAULT_TRANSMISSION_TYPE

  const label = i18n.t('COMMON.TRANSMISSION')

  const FIRST_OPTION = isSelectToggle
    ? {
        literal: i18n.t('COMMON.ALL'),
        value: DEFAULT_TRANSMISSION_TYPE
      }
    : {label: i18n.t('COMMON.ALL'), id: DEFAULT_TRANSMISSION_TYPE}

  const transmissionTypesOptions = transmissionTypes.map(({id, label}) =>
    isSelectToggle && wrapper === LEGACY_WRAPPER
      ? {
          literal: label,
          value: id
        }
      : {
          icon: ICONS_BY_TRANSMISSION_TYPE[id],
          id,
          label: i18n.t(label)
        }
  )

  const options = [FIRST_OPTION, ...transmissionTypesOptions]

  const _handleChange = (e, {value}) => {
    onChange(e, {
      field: FILTER_NAMES.TRANSMISSION_TYPE,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.TRANSMISSION_TYPE],
      value
    })
  }

  const handleChange = ({value: selectedValue}) => {
    const [firstValue] = selectedValue
    _handleChange(null, {value: firstValue})
  }

  if (wrapper === LEGACY_WRAPPER) {
    return isSelectToggle ? (
      <FormSelectToggle label={label} onChange={_handleChange} options={options} value={currentValue} />
    ) : (
      <FormSelect
        label={label}
        onChange={_handleChange}
        options={options}
        size={formSelectSizes.LARGE}
        value={currentValue}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          allSelectionsLabel: i18n.t('COMMON.ALL'),
          label,
          name: FILTER_NAMES.TRANSMISSION_TYPE,
          options: transmissionTypesOptions,
          showLabel: true,
          type
        }
      ]}
      group={`${FILTER_NAMES.TRANSMISSION_TYPE}Group`}
      legend={i18n.t('COMMON.TRANSMISSION')}
      onChange={({value}) => {
        handleChange({value: value.filter(id => id !== allSelectionsId)})
      }}
      overlayContentRef={overlayContentRef}
      placeholder={value ? transmissionTypesOptions.find(({id}) => id === value)?.label : i18n.t('COMMON.ALL')}
      showLegend={withLabel}
      value={{[FILTER_NAMES.TRANSMISSION_TYPE]: [value || allSelectionsId]}}
      wrapper={wrapper}
    />
  )
}

FormTransmission.displayName = 'FormTransmission'
FormTransmission.propTypes = {
  isSelectToggle: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  type: PropTypes.string,
  value: PropTypes.number,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

const FormTransmissionSelectToggle = props => <FormTransmission {...props} isSelectToggle />
FormTransmissionSelectToggle.displayName = 'FormTransmissionSelectToggle'

const FormTransmissionSelectMemo = memo(FormTransmission)
FormTransmissionSelectMemo.displayName = 'FormTransmissionSelectMemo'

const FormTransmissionSelectToggleMemo = memo(FormTransmissionSelectToggle)
FormTransmissionSelectToggleMemo.displayName = 'FormTransmissionSelectToggleMemo'

export {
  FormTransmissionSelectMemo as FormTransmissionSelect,
  FormTransmissionSelectToggleMemo as FormTransmissionSelectToggle
}

export default memo(FormTransmission)
